// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"16":"c5bd677ead894f4a","581":"961862fd611ce46c","865":"3a7f46d4b04cb472"}[chunkId] + ".js";
};